import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, CircularProgress } from "@mui/joy";
import { getFetch } from "../../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./phoneinbound.module.css";
import ExtensionFollowMeModal from "./extensionfollowmemodal";

const toastOptions : any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored"
};

//010-0000-0000 표시용 하이픈 (서버 mobile은 숫자만 11자리)
const formatPhone = (raw : string) => {
    const digits = String(raw || "").replace(/\D/g, "");
    if (digits.length < 4) return digits;
    if (digits.length < 8) return digits.slice(0, 3) + "-" + digits.slice(3);
    return digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
};

//정렬: 외근 중 먼저 → 이름순
const sortRows = (list : any[]) => {
    return [...list].sort((a, b) => {
        const aa = a.awayOn ? 1 : 0;
        const ab = b.awayOn ? 1 : 0;
        if (aa !== ab) return ab - aa;
        return String(a.name).localeCompare(String(b.name), "ko");
    });
};

//내선전화관리 — 본사 내선의 외근(Follow Me 휴대폰 착신)·휴대폰 번호 관리
//상태는 서버가 교환기 astdb에서 읽어온 값 그대로 (유선전화기 *21 토글과 자동 동기)
const ExtensionManageModal : React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedExt, setSelectedExt] = useState<string | null>(null);

    useEffect(() => {
        if (props.open) {
            setSelectedExt(null);
            load();
        }
    }, [props.open]);

    const load = async () => {
        setLoading(true);
        try {
            const result : any = await getFetch("/dashboard/callcenter/followme");
            if (result.message === "success") {
                setRows(result.extensions || []);
            } else {
                toast.error(result.message === "CALLCENTER_DISABLED" ? "콜센터 모듈이 서버에서 비활성화되어 있습니다" : (result.message || "내선 목록을 불러오지 못했습니다"), toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("내선 목록을 불러오지 못했습니다", toastOptions);
        }
        setLoading(false);
    };

    //상세 모달에서 저장/토글 성공 시 서버가 astdb를 재읽은 행으로 갱신
    const onChanged = (updated : any) => {
        if (!updated) return;
        setRows((prev) => prev.map((r) => r.extension === updated.extension ? { ...r, awayOn: updated.awayOn, mobile: updated.mobile } : r));
    };

    const sorted = sortRows(rows);
    const awayCount = rows.filter((r) => r.awayOn).length;

    return (
        <>
            <Modal open={props.open} onClose={props.onClose}>
                <ModalDialog>
                    <div style={{ width: "520px" }}>
                        <div className={styles.fmHeaderRow}>
                            <div className={styles.fmTitleWrap}>
                                <span className={styles.modalTitle} style={{ marginBottom: 0 }}>내선전화관리</span>
                                <span className={`${styles.pbxBadge} ${props.pbxConnected ? "" : styles.pbxBadgeOff}`}>
                                    <span className={styles.dot} />{props.pbxConnected ? "교환기 연결됨" : "교환기 연결 끊김"}
                                </span>
                            </div>
                            <span className={styles.fmAwayCount}>외근 켜짐 {awayCount}명</span>
                        </div>
                        <div className={styles.fmSub}>본사팀 · {rows.length}명 · 행을 클릭해 휴대폰 번호와 외근을 설정합니다</div>

                        {
                            loading ?
                                <div className={styles.loadingBox}><CircularProgress /></div>
                                :
                                sorted.length === 0 ?
                                    <div className={styles.empty}>등록된 본사 내선이 없습니다.</div>
                                    :
                                    <div className={styles.fmList}>
                                        {
                                            sorted.map((r : any) => (
                                                <div
                                                    key={r.extension}
                                                    className={`${styles.fmRow} ${r.awayOn ? styles.fmRowAway : ""}`}
                                                    onClick={() => setSelectedExt(r.extension)}
                                                >
                                                    <div className={`${styles.nameCol} ${styles.fmNameCol}`}>
                                                        <span className={styles.name}>{r.name}</span>
                                                        <span className={styles.ext}>{r.extension}</span>
                                                    </div>
                                                    <span className={r.mobile ? styles.fmPhone : styles.fmPhoneEmpty}>
                                                        {r.mobile ? formatPhone(r.mobile) : "휴대폰 미등록"}
                                                    </span>
                                                    <span className={`${styles.statusBadge} ${r.awayOn ? styles.fmBadgeAway : styles.fmBadgeOffice}`}>
                                                        {r.awayOn ? "외근 중" : "사무실"}
                                                    </span>
                                                </div>
                                            ))
                                        }
                                    </div>
                        }

                        <div className={styles.modalButtons}>
                            <Button variant="plain" color="neutral" onClick={props.onClose}>닫기</Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>

            <ExtensionFollowMeModal
                open={!!selectedExt}
                onClose={() => setSelectedExt(null)}
                row={selectedExt ? (rows.find((r) => r.extension === selectedExt) || null) : null}
                onChanged={onChanged}
            />
        </>
    );
};

export default ExtensionManageModal;
